/**
 * Spend Trend Chart
 * Line chart showing daily spend over time
 */

import LineChart from '@/components/charts/LineChart';
import type { DailySpend } from '../types';

interface SpendTrendChartProps {
  data: DailySpend[];
  currency: string;
}

function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
}

export function SpendTrendChart({ data, currency }: SpendTrendChartProps) {
  const chartData = data.map((item) => ({
    name: formatDate(item.date),
    amount: item.amount,
  }));

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Daily Spend Trend</h3>
      <div className="text-sm text-gray-500 mb-4">Last 30 days of cloud spending</div>
      <LineChart
        data={chartData}
        xAxisKey="name"
        series={[
          { dataKey: 'amount', name: 'Daily Spend', color: '#3b82f6' },
        ]}
        height={280}
        showGrid
      />
      <div className="mt-4 text-xs text-gray-500 text-right">
        Values in {currency}
      </div>
    </div>
  );
}
